import React, { useEffect } from 'react';
import { Stack } from '@mantine/core';
import EventLoading from '../EventLoading';
import { EventHeading } from '../EventHeadings/EventHeading';
import { EventDetails } from '../shared/Event.details';
import { DeliveryFinancial } from './DeliveryFinancial';
import { deliveryDownloadConfig } from '../DeliveryUpcoming/config';
import { EventDownload } from '../shared/Event.download';
import { getRestaurantInfo } from '../helpers';
import { useDeliveryCompletedEvent } from './useDeliveryCompletedEvent';
import useTrackEvent from '../useTrackEvent';

export const DeliveryCompleted: React.FC<{ id: string; onCloseWithoutEvent: () => void }> = ({
  id,
  onCloseWithoutEvent,
}) => {
  const { event, financialSummary, loading } = useDeliveryCompletedEvent(id);

  useTrackEvent(event);

  useEffect(() => {
    if (!loading && !event) {
      onCloseWithoutEvent();
    }
  }, [loading, event, onCloseWithoutEvent]);

  if (loading) {
    return <EventLoading />;
  }

  if (!event) {
    return <></>;
  }

  const eventTitle = `${event.productType.toLowerCase()} Event Details`;
  const eventDetails = {
    manifestTime: event.selectEvent.startTime,
    readyAndBaggedTime: event.selectEvent.readyAndBaggedTime,
    restaurant: getRestaurantInfo(event.vendor?.internalName, event.vendor?.address),
    placeName: event.selectEvent.account.name,
  };

  const eventDownloadDetails = {
    ...deliveryDownloadConfig,
    leftDownloadUrl: event.preManifestDocument?.documentUrl || '',
    rightDownloadUrl: event.finalManifestDocument?.documentUrl || '',
  };

  return (
    <EventHeading eventStartTime={event.selectEvent.startTime} title={eventTitle}>
      <Stack gap="md">
        <EventDetails eventDetails={eventDetails} />
        {financialSummary && <DeliveryFinancial {...financialSummary} />}
        <EventDownload eventDownloadDetails={eventDownloadDetails} />
      </Stack>
    </EventHeading>
  );
};
